import { apiFetch } from "./client";

// Returns [{ id, full_name }]
export const listProfessors = () => apiFetch("/api/users?role=professor");
